import { HelpPanel } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../hooks/localizedText';

const I18N = 'waitlistsTab.info';

/**
 * The "Waitlists" Help panel shown in the Volunteer Activity AppLayout tools slot, opened by the Info
 * link on each Waitlists-tab event card. Mirrors the codebase's *HelpPanel pattern (e.g. GrantInfoHelpPanel).
 */
export function WaitlistInfoHelpPanel() {
  const { t } = useLocalizedText(['activity', 'translation']);
  return (
    <HelpPanel header={<h2>{t(`${I18N}.title`)}</h2>}>
      <h3>{t(`${I18N}.howItWorks.title`)}</h3>
      <p>{t(`${I18N}.howItWorks.body`)}</p>
      <h3>{t(`${I18N}.notifications.title`)}</h3>
      <p>{t(`${I18N}.notifications.body`)}</p>
      <h3>{t(`${I18N}.keepUpToDate.title`)}</h3>
      <p>{t(`${I18N}.keepUpToDate.body`)}</p>
      <h3>{t(`${I18N}.contact.title`)}</h3>
      <p>{t(`${I18N}.contact.bodySalaried`)}</p>
      <p>{t(`${I18N}.contact.bodyHourly`)}</p>
    </HelpPanel>
  );
}
